import { Alert, Card, Link } from '@perch-labs/shrike';
import { Row } from 'styles';
import { copyFor } from 'config';
import { CardContent } from '../../check-lmi-eligibility.style';

interface LmiContractErrorProps {
  refetchAll: () => void;
}

const getCopy = copyFor('settings.checkLmiEligibility');

export const LmiContractError = ({ refetchAll }: LmiContractErrorProps) => (
  <Card>
    <CardContent>
      <Row style={{ width: '75%' }}>
        <Alert>{getCopy('selfAttestation.error')}</Alert>
        <Link hideIcon onClick={refetchAll} openInNewTab={false}>
          {getCopy('selfAttestation.tryAgain')}
        </Link>
      </Row>
    </CardContent>
  </Card>
);
